import type React from 'react';
import {
  useVehicleHref,
  useSetSearchRequestIdCookie
} from '@/SearchResults/ResultTileV2/helpers/ResultTile.helpers';
import { useTileDataContext } from '~/contexts/TileDataContext';
import useSendTileInfoEvent from './useSendTileInfoEvent';

type OwnProps = React.PropsWithChildren<{}>;

const TileContainer = ({ children }: OwnProps) => {
  const { tileData } = useTileDataContext();
  const href = useVehicleHref(tileData);
  const setSearchRequestCookieId = useSetSearchRequestIdCookie();
  const sendTileInfoEvent = useSendTileInfoEvent();

  const handleOnClick = event => {
    if (event.target === event.currentTarget) {
      setSearchRequestCookieId();
      sendTileInfoEvent(tileData);
    }
  };

  return (
    <div
      className="h-[368px] m:border m:border-grey-2 m:border-solid m:rounded-md"
      data-qa="result-tile"
      id={`vehicle-${tileData?.vehicleId}`}
    >
      <a href={href} onClick={handleOnClick} data-analytics-id="result-tile-v2">
        <div className="bg-white grid grid-cols-1 grid-rows-[186px_1fr] h-full hover:shadow-[0px_6px_13px_rgba(24,53,88,0.1)] overflow-hidden pointer-events-none rounded-md shadow-[0px_2px_3px_rgba(24,53,88,0.1)] w-full">
          {children}
        </div>
      </a>
    </div>
  );
};

export default TileContainer;
